<h2 class="pb-s">
  An-/Ummeldung
</h2>
<p>
  Über die An- und Ummeldemaske haben Sie selbst die <strong>Kontrolle und Flexibilität</strong> eine neue Person als Beauftragte*n zum Programm anzumelden oder eine bestehende Person umzumelden.
</p>
<p>
  Der besondere Vorteil dieser Funktion liegt in ihrer Benutzerfreundlichkeit und Effizienz. Sie <strong>sparen wertvolle Zeit</strong> und vermeiden Kommunikationsfehler. Zudem haben Sie die volle Kontrolle über Ihre Ansprechpartner und können sicherstellen, dass <strong>wichtige Informationen immer an die richtige Person gelangen</strong>.
</p>
<h2 class="pb-l mt-l">Sie möchten uns eine/n Beauftragte*n melden oder einen anderen Beauftragten aus Ihrem Team benennen?</h2>
<form class="row">
  <div class="col-md-9">
    <mat-checkbox type="checkbox" class="mat-checkbox mat-accent ng-untouched ng-pristine ng-invalid" id="mat-checkbox-1" required="">
      Ja, ich möchte eine/n Beauftragte*n für unsere Apotheke melden.
    </mat-checkbox>
  </div>
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Vorname Beauftragte*r</mat-label>
      <input matInput readonly>
    </mat-form-field>
  </div>
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nachname Beauftragte*r</mat-label>
      <input matInput readonly>
    </mat-form-field>
  </div>
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Tätigkeit in der Apotheke</mat-label>
      <input matInput readonly>
    </mat-form-field>
  </div>
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Telefonnummer bei Rückfragen</mat-label>
      <input matInput readonly>
    </mat-form-field>
  </div>
  <div class="col-md-12">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label style="white-space: pre" class="textarea-label">Anmerkungen und Fragen</mat-label>
      <textarea matInput
                readonly></textarea>
    </mat-form-field>
    <button class="btn-primary on-dark-bg mr-l">
      Anfrage Senden
    </button>
  </div>
</form>

<p class="mt-xl">
  Erhalten Sie in unserem Video einen umfassenden Einblick zu den Themen unseres Beauftragtenprogramms und melden Sie sich gleich an.
</p>

<div class="text-center mt-l screen-background">
  <img src="../../assets/dummy/videoo.png">
</div>
